import { Badge, withStyles } from '@material-ui/core';

const ChipBadge = withStyles(() => ({
  badge: {
    top: 14,
    left: 5,
    backgroundColor: '#D81F27',
    color: 'white',
  },
}))(Badge);

export default ChipBadge;
